export default __webpack_public_path__ + "static/fcw-c33e20bf6bf9ce2bdb19fe8981114da0.mp4";